/**
 * 404 NotFound - catches everything that didn't match a real route.
 *
 * Per CHAP-78.
 */
import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();
  return (
    <div className="space-y-3 min-w-0">
      <div className="bg-white rounded-xl border border-gray-100 p-6 text-center">
        <p className="text-xs uppercase tracking-wider text-neutral font-semibold">404</p>
        <h2 className="text-navy text-xl sm:text-2xl font-bold mt-1">Page not found</h2>
        <p className="text-neutral text-sm mt-2">
          <code className="font-mono text-gray-700">{location.pathname}</code> doesn't match any route.
        </p>
        <Link to="/" className="inline-block mt-4 text-orange hover:text-orange-dark text-sm font-medium underline">
          Go home
        </Link>
      </div>
    </div>
  );
}
